const s = {
  name: "FinanceDataCore",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,2H0V0h35V2z"/>
		<path class="st0" d="M12,8H0V6h12V8z"/>
		<path class="st0" d="M40,8H20V6h20V8z"/>
		<path class="st0" d="M40,2h-2V0h2V2z"/>
		<path class="st0" d="M5,38h35v2H5V38z"/>
		<path class="st0" d="M0,38h2v2H0V38z"/>
		<path class="st0" d="M17,8h-2V6h2V8z"/>
		<path class="st0" d="M28,32h12v2H28V32z"/>
		<path class="st0" d="M0,32h20v2H0V32z"/>
		<path class="st0" d="M23,32h2v2h-2V32z"/>
		<path class="st0" d="M14,14h12v12H14V14z M16,16v8h8v-8H16z"/>
		<path class="st0" d="M38,21v-9h2v9H38z"/>
		<path class="st0" d="M0,28v-9h2v9H0z"/>
		<path class="st0" d="M29,19h6v2h-6V19z"/>
		<path class="st0" d="M5,19h6v2H5V19z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FinanceDataCore
};
